<template>
  <div class="about">
    <section class="about__intro">
      <v-container>
        <v-heading level="h1">{{page.title}}</v-heading>
        <body-text v-html="page.description"></body-text>
      <!-- <v-btn :small="true" tag="router-link" to="/pre-agendamento" model="color-b">
        Faça um pré agendamento
      </v-btn> -->
        <div class="about__photos">
          <img src="@/assets/img/urc-shape.svg" class="urc-shape" alt="URC">
          <v-gallery :images="page.structure" />
        </div>
      </v-container>
    </section>
    <section class="about__details">
      <v-container>
        <ul class="row about__principles">
          <li class="col-4">
            <v-heading level="h2">Missão</v-heading>
            <p>{{page.mission}}</p>
          </li>
          <li class="col-4">
            <v-heading level="h2">Visão</v-heading>
            <p>{{page.vision}}</p>
          </li>
          <li class="col-4">
            <v-heading level="h2">Valores</v-heading>
            <p>{{page.values}}</p>
          </li>
        </ul>
        <v-services />
        <pre-schedule />
      </v-container>
    </section>
    <locations-map />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';
import Gallery from '@/components/widgets/Gallery.vue';
import seeMedicalStaff from '@/components/widgets/SeeMedicalStaff.vue';
import Services from '@/components/widgets/Services.vue';
import LocationsMap from '@/components/location/LocationsMap.vue';
import Btn from '@/components/uikit/Btn.vue';

const meta = [
  {
    vmid: 'og:title',
    name: 'og:title',
    template: 'Sobre o URC',
  },
  {
    vmid: 'description',
    name: 'description',
    content: 'Equipamentos de alta tecnologia e qualidade para imagens de Raio-X, mamografia, tomografia e densitometria. Primeira e única clínica em SJC que possui a ressonância magnética de campo aberto de alta resolução.',
  },
  {
    vmid: 'og:description',
    name: 'og:description',
    content: 'Equipamentos de alta tecnologia e qualidade para imagens de Raio-X, mamografia, tomografia e densitometria. Primeira e única clínica em SJC que possui a ressonância magnética de campo aberto de alta resolução.',
  },
];

export default {
  name: 'About',
  components: {
    'v-btn': Btn,
    'v-container': Container,
    'v-heading': Heading,
    'body-text': BodyText,
    'v-gallery': Gallery,
    'v-services': Services,
    'pre-schedule': seeMedicalStaff,
    'locations-map': LocationsMap,
  },
  metaInfo: {
    title: 'Sobre o URC',
    meta,
  },
  computed: {
    ...mapState({
      page: state => state.about.content,
    }),
  },
  async created() {
    await this.$store.dispatch('about/getContent');
  },
};
</script>

<style lang="scss" scoped>
$component: '.about';
#{$component} {
  &__intro {
    overflow: hidden;
    padding: $section-gutter 0 $section-margin;
    .container {
      display: grid;
      grid-template-columns: repeat(2, 50%);
      grid-template-rows: auto;
      grid-gap: 0 $gutter-l;
      @media screen and (max-width: #{$brakepoint-large}) {
        grid-template-columns: 55% 45%;
      }
      @media screen and (max-width: #{$brakepoint-medium}) {
        display: block;
      }
    }
     h1.heading {
      color: $color-a;
      grid-column: 1 / 3;
      grid-row: 1 / 2;
    }
    .body-text {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
    .btn{
      max-width: 300px;
      margin-bottom: $gutter-xxxl;
      @media screen and(max-width: 768px){
        margin-left: 50%;
        transform: translateX(-50%);
      }
    }
    #{$component}__photos {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      position: relative;
      .urc-shape {
        position: absolute;
        z-index: -1;
        width: 624px;
        top: 0;
        left: 50%;
        transform: translate(-50%, -150px);
        @media screen and (max-width: #{$brakepoint-large}) {
          width: 384px;
          transform: translate(-50%, -80px);
        }
        @media screen and (max-width: #{$brakepoint-medium}) {
          display: none;
        }
      }
    }
  }
  &__details {
    margin: 0;
    padding: $section-gutter 0;
    background-color: $bg-gray;
  }
  &__principles {
    margin-bottom: $section-margin;
    li {
      padding: $gutter-l;
      .heading {
        color: $color-b;
      }
      p {
        font-size: $font-size-xl;
      }
    }
  }
  .services {
    margin-bottom: $section-margin;
  }
}
</style>
